import React, { useEffect, useState } from "react";
import "./Guide.css";
import { useNavigate } from "react-router-dom";
import { generateSpeech, saveOnboarding } from "../../../Actions/ChatActions";
import { getConsentFlag, getTooltip, getUserToken, saveOnboardingFlag, stopPlayingAudio,
  handleTooltipOnboarding,
  CheckLanguageSupport,
  setLanguageChangeFlag,
  isIframeDeployment,
} from "../../../Actions/Utils";
import ToastMessage from "../../../Shared/Components/ToastMessage/ToastMessage";
import { ToastSeverityMap } from "../../../NewConstants/ToastConstants";
import { guideAudio, guideButtons, guideCards, guideHeading } from "../../../NewConstants/GuideConstant";
import { languageLabel } from "../../../NewConstants/Language-Constants";
import NextBtn from "../../../Shared/Components/NextBtn/NextBtn";
import PwaInstallBanner from "../../../Shared/Components/PwaInstallBanner/PwaInstallBanner";
import { navTitle } from "../../../NewConstants/NavConstants";
const Guide = ({ selectedLanguage, audioRef, setStepIndex, setStartTour }) => {
  const navigate = useNavigate();
  const [showSpeakerActive, setShowSpeakerActive] = useState(true);
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const [userStoppedAudio, setUserStoppedAudio] = useState(false);

  useEffect(() => {
    if (!getUserToken()) {
      sessionStorage.clear();
      localStorage.clear();
      navigate("/login");
    }
    const handleVisibilityChange = () => {
      stopPlayingAudio(audioRef);
      setShowSpeakerActive(false);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    window.history.pushState(null, document.title, window.location.href);
    const handlePopState = (event) => {
      window.history.pushState(null, document.title, window.location.href);
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('popstate', handlePopState);
    }
  }, []);

  useEffect(() => {
    const handleAudio = async () => {
        const res = await generateSpeech(guideAudio[selectedLanguage], selectedLanguage);
        if (res?.data?.url) {
          const newAudio = new Audio(res?.data?.url);
          if (audioRef.current) {
            audioRef.current.pause();
          }
          
          newAudio.addEventListener("ended", () => {
            setShowSpeakerActive(false);
          });
    
          audioRef.current = newAudio;
          newAudio.play().catch((err) => {
            console.error("Error playing audio:", err);
          });
        } else {
          setToastErrorMessage(res?.data?.detail)
          setShowToastMessage(true);
        }
    };
  
    if (!userStoppedAudio && showSpeakerActive) {
      handleAudio();
    }
  }, [showSpeakerActive]);

  const handleNext = async () => {
    const res = await saveOnboarding(getUserToken(), true, selectedLanguage);
    if (res?.status === 200) {
      saveOnboardingFlag(true);
      if (getConsentFlag() || isIframeDeployment()) {
        stopPlayingAudio(audioRef);
        await navigateBasedOnSupport();
      } else {
        stopPlayingAudio(audioRef);
        navigate("/consent");
      }
    }
    if (res?.status === 401) {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/login");
    }
    if(res?.status === 500) {
      setToastErrorMessage(res?.data?.detail)
      setShowToastMessage(true);
    }
  };

  const navigateBasedOnSupport = async () => {
    const route = await CheckLanguageSupport();
    if (route === "chat"){
      const tooltip = getTooltip();
      handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
      navigate("/chat");
    }else if (route === "language-check"){
      navigate("/language-check");
    }else{
      navigate("/login");
    }
  };
  const handleLanguageChange = () => {
    setLanguageChangeFlag("false");
    stopPlayingAudio(audioRef);
    navigate("/lang");
  };
  return (
    <div className="h-screen w-screen flex flex-col">
      <PwaInstallBanner selectedLanguage={selectedLanguage} />
      {isIframeDeployment() ? (
          <div className="fixed top-0 h-[3.75rem] w-full flex justify-end bg-[var(--primary-dark-2)]">
          </div>
        ) : (
          <div className="h-[3.75rem] py-4 w-screen text-lg text-[var(--primary-dark)] font-semibold flex justify-center items-center bg-[var(--neutral-white)]" >{navTitle[selectedLanguage]}</div>
        )}
      <div className="guide-page flex-1 w-screen flex items-start justify-center py-6 overflow-y-scroll" style={{ backgroundImage: `url(/Assets/Images/bgWallpaper.svg)` }}>
        <div className="guide-page-content  w-[90%] flex flex-col items-center justify-center rounded-2xl bg-white px-1">
          <div className="guide-page-content-header h-[3rem] px-4 w-full flex items-center justify-between my-3">
            <div className="guide-page-content-header-left flex items-center justify-center" onClick={handleLanguageChange}>
              <img src={isIframeDeployment() ? "/Assets/Images/GlobeRed.svg" : "/Assets/Images/GlobeBlue.svg"} alt="globe" className="w-5 h-5 mr-2"/>
              <span className="text-[color:var(--primary-dark)] font-bold text-md">{languageLabel[selectedLanguage] || ""}</span>
              <svg className="ml-2 w-4 h-4" fill="none" stroke="var(--primary-dark)" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
            </div>
            <div
              className={`speakerDiv ${showSpeakerActive ? "Active" : ""
                }`}
                onClick={() => {
                  const newState = !showSpeakerActive;
                  setShowSpeakerActive(newState);
                  setUserStoppedAudio(!newState);
                  stopPlayingAudio(audioRef);
                }}
            >
              {showSpeakerActive ? guideButtons.stop[selectedLanguage] : null}
              {showSpeakerActive ? (
                <div className="">
                  <img
                    src={isIframeDeployment() ? "/Assets/Images/RedSpeaker.svg" : "/Assets/Images/blueSpeaker.svg"}
                    alt="active Speaker" 
                    className="w-10 h-10"
                  />
                </div>
              ) : (
                <div className="">
                  <img src={"/Assets/Images/crossSpeakerIcon.svg"} alt="speaker" />
                </div>
              )}
            </div>
          </div>
          <div className="guide-page-image-body h-full w-full flex items-center justify-center rounded-md">
            <img src="/Assets/Images/Lady_Illustrations/Onboarding.svg" className="w-full h-[10rem]" alt="guide" />
          </div>
          <div className="guide-page-content-heading-body h-[2rem] w-full flex items-center justify-center my-4">
            <span className="text-black font-bold text-[1.283rem]">{guideHeading[selectedLanguage]}</span>
          </div>
          <div className="guide-page-content-body  px-3 w-full flex flex-col items-center gap-4 py-4">
            {guideCards.map((card, index) => (
              <div key={index} className="w-full max-w-md flex flex-col items-start gap-1 rounded-xl py-2 px-3 shadow-sm" style={{backgroundColor: card.bg_color}}>
                <img src={card.image} alt="Learn Icon" className="w-6 h-6" />
                <span className="font-medium text-lg" style={{color: card.text_color}}>{card.text[selectedLanguage]}</span>
              </div>
            ))}
          </div>
          <div className="guide-page-content-footer py-4 px-4 w-full flex items-center justify-between">
            <NextBtn
              value={guideButtons.next[selectedLanguage]}
              icon={"/Assets/Images/nextWhiteIcon.svg"}
              bgColor={"var(--primary-dark)"}
              color={"var(--neutral-white)"}
              nextClick={handleNext}
              btnFullWidth={true}
              pady={7}
              textCenter={true}
            />
          </div>
        </div>
      </div>
      {
        showToastMessage && <ToastMessage message={toastErrorMessage} severity={ToastSeverityMap.error} direction={"bottom"} close={setShowToastMessage}/>
      }
    </div>
  );
};

export default Guide;